import { ForecastTimelineFilterProperty } from '@/coreDomainsModule/entities/filter';
import { ICustomerForecastTimelineFilterContentItem } from '../domains/entities/customerForecastTimelineState';

/**
 * 客先内示遍歴のフィルター情報のアダプタ
 */
export class CustomerForecastTimelineFilterAdapter {
  /**
   * フィルター情報のアダプタ
   * @param filterInfos - フィルター
   */
  public static adapt = (filterInfos?: ICustomerForecastTimelineFilterContentItem[]): ForecastTimelineFilterProperty => {
    const result: ForecastTimelineFilterProperty = {
      staffName: undefined,
      warehouseCode: undefined,
      warehouse: undefined,
      supplierCode: undefined,
      supplierName: undefined,
      businessCode: undefined,
      businessName: undefined,
      packageAmount: undefined,
      customerCode: undefined,
      customerName: undefined,
      salesDestinationCode: undefined,
      salesDestinationName: undefined,
    };

    if (!filterInfos) {
      return result;
    }

    filterInfos.forEach((filterInfo) => {
      const value = filterInfo.selectedValue === undefined || filterInfo.selectedValue === '' ? undefined : filterInfo.selectedValue;

      switch (filterInfo.filterType) {
        case 'FORECAST_TIMELINE_STAFF_NAME':
          result.staffName = value;
          break;
        case 'FORECAST_TIMELINE_WAREHOUSE_CODE':
          result.warehouseCode = value;
          break;
        case 'FORECAST_TIMELINE_WAREHOUSE':
          result.warehouse = value;
          break;
        case 'FORECAST_TIMELINE_SUPPLIER_CODE':
          result.supplierCode = value;
          break;
        case 'FORECAST_TIMELINE_SUPPLIER_NAME':
          result.supplierName = value;
          break;
        case 'FORECAST_TIMELINE_BUSINESS_CODE':
          result.businessCode = value;
          break;
        case 'FORECAST_TIMELINE_BUSINESS_NAME':
          result.businessName = value;
          break;
        case 'FORECAST_TIMELINE_PACKAGE_AMOUNT':
          result.packageAmount = value === undefined ? undefined : Number(value);
          break;
        case 'FORECAST_TIMELINE_CUSTOMER_CODE':
          result.customerCode = value;
          break;
        case 'FORECAST_TIMELINE_CUSTOMER_NAME':
          result.customerName = value;
          break;
        case 'FORECAST_TIMELINE_SALES_DESTINATION_CODE':
          result.salesDestinationCode = value;
          break;
        case 'FORECAST_TIMELINE_SALES_DESTINATION_NAME':
          result.salesDestinationName = value;
          break;
      }
    });

    return result;
  };
}
